const stickyFilters = {
  stuckClass: "activeClass",

  init() {
    this.setStickyClass();
  },

  setStickyClass() {
    const onScroll = () => {
      const els = document.querySelectorAll(".cat-main__section") as NodeListOf<HTMLElement>;
      const deskNav = document.getElementById('jsDeskNav') as HTMLElement; 
      const header = document.getElementById('jsStickyHeader') as HTMLElement; 
      const catList = document.getElementById('jsCatList') as HTMLElement;

      els.forEach((el) => {
        const stickyTop = parseFloat(getComputedStyle(el).top) || 0;
        const rect = el.getBoundingClientRect();
        const isStuck = rect.top <= stickyTop + 1;

        el.classList.toggle(this.stuckClass, isStuck);
        deskNav?.classList.toggle(this.stuckClass, isStuck);
        header?.classList.toggle(this.stuckClass, isStuck);
        catList?.classList.toggle(this.stuckClass, isStuck);

      }); 
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    onScroll();
  },
};

export default stickyFilters;